export default "__VITE_ASSET__MfNvUhXK__"